import moment from 'moment';

export class DateFormatValueConverter {
    toView(value, format) {
        if (format != null && value != null) {
            return moment(value).format(format);
        } else {
            return value;
        }
    }
}

